import Vue from 'vue'
import axios from 'axios'
import env from './env'
import store from './store/index'
import router from './routes/index'
import clientVersion from './utils/clientVersion'

const api = axios.create({
  baseURL: env.apiUrl,
})

api.interceptors.request.use(
  function (config) {
    config.headers['X-Client-Platform'] = 'web'
    config.headers['X-Client-Version'] = env.buildNumber
    const accessToken = store.state.auth.token.access_token
    const verificationToken = store.state.auth.verificationToken.token
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }
    if (verificationToken) {
      config.headers['Verification-Token'] = verificationToken
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  },
)

api.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    if (
      error.response &&
      error.response.status === 426 &&
      error.response.data &&
      error.response.data.code === 'CLIENT_VERSION_UNSUPPORTED'
    ) {
      clientVersion.minimumVersion = error.response.data.minimum_version
      clientVersion.unsupported = true
    }
    // Check if backend requires MFA
    if (error.response && error.response.status === 403) {
      const data = error.response.data
      if (data && data.mfa_required) {
        store.dispatch('auth/handleMfaRequired', {
          channel: data.mfa_channel,
          token_id: data.token_id,
          attempts_remaining: data.attempts_remaining,
          otp_expires_at: data.otp_expires_at,
        })
      }
      // Project-share BA grace period expired — backend is hard-blocking API
      // calls. Push them to onboarding so they can finish their company profile.
      if (data && data.error_code === 'PROFILE_COMPLETION_REQUIRED') {
        const current = router.currentRoute && router.currentRoute.name
        if (current !== 'auth.onboarding-company') {
          router.replace({ name: 'auth.onboarding-company' }).catch(() => {})
        }
      }
    }
    return Promise.reject(error)
  },
)

Vue.prototype.$api = api

export default api
